module.exports = __webpack_public_path__ + "img/kr.cdb6aa9e.png";